import React, { useEffect } from 'react';
import UserAvatarInfo from '../user-avatar-info/user-avatar-info';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import './users-selector.scss';

export enum UserSelectorMode {
	single = 'single',
	multiple = 'multiple'
}

interface UserSelectorProps extends Pick<SelectProps<number[]>, 'size' | 'value' | 'onSearch' | 'notFoundContent'> {
	users: Partial<Bringg.User>[];
	placeholder: string;
	className?: string;
	isDisabled?: boolean;
	onChange(values): void;
	isOptionDisabled?(user: Partial<Bringg.User>): boolean;
	selectedIds?: number[];
	parentContainerClass?: string;
	height?: number;
	width?: number | string;
	mode?: UserSelectorMode;
}

const UsersSelector = ({
	users,
	placeholder,
	onChange,
	selectedIds,
	isDisabled,
	isOptionDisabled,
	className,
	parentContainerClass,
	height = 200,
	width = 350,
	mode = UserSelectorMode.multiple,
	...selectProps
}: UserSelectorProps) => {
	const otherProps = { ...selectProps };
	useEffect(() => {
		otherProps['getPopupContainer'] = () => document.querySelector(`.${parentContainerClass}`);
	}, [parentContainerClass]);

	const renderOption = (user: Partial<Bringg.User>) => {
		return {
			value: user.id,
			label: <UserAvatarInfo user={user} />,
			disabled: isOptionDisabled ? isOptionDisabled(user) : false,
			username: user.name,
			'data-test-id': `users-selector-user-${user.name}`,
			role: 'option'
		};
	};

	const filterOptions = (input, option) => {
		return option.username?.toLowerCase().includes(input?.toLowerCase());
	};

	return (
		<div className={`users-selector ${className ? className : ''}`}>
			<Select
				disabled={isDisabled}
				mode={mode === UserSelectorMode.single ? null : UserSelectorMode.multiple}
				showSearch
				allowClear
				style={{ width, maxHeight: height, overflow: 'auto' }}
				placeholder={placeholder}
				onChange={onChange}
				defaultValue={selectedIds || []}
				className="users-select"
				popupClassName="users-select-dropdown"
				options={users.map(renderOption)}
				filterOption={filterOptions}
				{...otherProps}
			/>
		</div>
	);
};

export default UsersSelector;
